import permission from './module/permission';

const directives = {
  permission,
};

export default directives;
